import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthRoutingModule } from './auth-routing.module';
import { AuthGuard } from './auth.guard';

@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        AuthRoutingModule
    ],
    providers: [
        AuthGuard
    ]

})
export class AuthModule { }
